import type { UserPaginationParams, AxiosRequestConfigExtended } from '@vision/ui/interfaces';
import type { PlannerListArgs, PlannerDetailArgs, PlannerRelatedCountArgs } from './planner.api.types';
import { buildEndpointWithQuery, insertIfObject } from '@vision/ui/utils';

export const buildGetPlannersRequest = ({ accountId }: PlannerListArgs): AxiosRequestConfigExtended => ({
  url: `/v2/planners`,
  method: 'GET',
  params: { account_id: accountId },
});

export const buildGetPlannerByIdRequest = ({
  accountId,
  plannerId,
}: PlannerDetailArgs): AxiosRequestConfigExtended => ({
  url: `/v2/planners/${plannerId}`,
  method: 'GET',
  params: { account_id: accountId },
});

export const buildFetchPlannerUsersWithPaginationRequest = ({
  nodeId,
  view,
  query,
  status,
  sortBy,
  sortOrder,
}: UserPaginationParams): AxiosRequestConfigExtended => ({
  url: buildEndpointWithQuery('/v2/planners/users', query),
  method: 'GET',
  params: {
    node_id: nodeId,
    ...insertIfObject(!!view, {
      view,
    }),
    ...insertIfObject(!!status, {
      status,
    }),
    ...insertIfObject(!!sortBy, {
      sort_by: sortBy,
    }),
    ...insertIfObject(!!sortOrder, {
      sort_order: sortOrder,
    }),
  },
});

export const buildRelatedPlannerCountRequest = ({
  accountId,
  objectId,
}: PlannerRelatedCountArgs): AxiosRequestConfigExtended => ({
  url: `/v2/planners/related_planner_count`,
  method: 'GET',
  params: { account_id: accountId, record_id: objectId },
});
